import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getCommentsForum } from 'store/lesson-actions';

import CommentContainer from './CommentContainer/CommentContainer';
import UserComment from './UserComment/UserComment';
import Loading from 'components/UI/Loading/Loading';

import classes from './Forum.module.css';

const Forum = props => {
  const { t } = useTranslation(['forum']);
  const dispatch = useDispatch();
  const dataLesson = useSelector(state => state.lessonInfo);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(getCommentsForum(props.idLesson, 'es', 50, 1, true));
  }, []);

  useEffect(() => {
    if (dataLesson.commentsForum !== null) {
      setIsLoading(false);
    }
  }, [dataLesson]);

  return (
    <section className={classes.forumContainer}>
      {!isLoading ? (
        <>
          <UserComment
            idLesson={props.idLesson}
            idCourse={props.idCourse}
          />
          <aside className={classes.commentsForum}>
            <p className={classes.totalComments}>
              {dataLesson.commentsForum.paginator.items}{' '}
              {t('comments')}
            </p>
            {dataLesson.commentsForum.comments.map(comment => (
              <CommentContainer
                key={comment.idComment}
                commentData={comment}
                idLesson={props.idLesson}
                idCourse={props.idCourse}
              />
            ))}
          </aside>
        </>
      ) : (
        <Loading />
      )}
    </section>
  );
};

Forum.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number
};

export default Forum;
